// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
import {
  QacConversationTokenUsage,
  QacConversationTokenUsageFromJSON,
  QacConversationTokenUsageToJSON,
  Upload,
  UploadFromJSON,
  UploadToJSON,
  UserMinified,
  UserMinifiedFromJSON,
  UserMinifiedToJSON,
} from "./";

/**
 *
 * @export
 * @interface QacConversationMessage
 */
export interface QacConversationMessage {
  /**
   *
   * @type {number}
   * @memberof QacConversationMessage
   */
  id: number;
  /**
   *
   * @type {number}
   * @memberof QacConversationMessage
   */
  thread: number;
  /**
   *
   * @type {string}
   * @memberof QacConversationMessage
   */
  authorType: QacConversationMessageAuthorTypeEnum;
  /**
   *
   * @type {UserMinified}
   * @memberof QacConversationMessage
   */
  author?: UserMinified;
  /**
   *
   * @type {string}
   * @memberof QacConversationMessage
   */
  role?: QacConversationMessageRoleEnum;
  /**
   *
   * @type {string}
   * @memberof QacConversationMessage
   */
  content: string;
  /**
   *
   * @type {string}
   * @memberof QacConversationMessage
   */
  contentHtml?: string;
  /**
   *
   * @type {Array<Upload>}
   * @memberof QacConversationMessage
   */
  attachments?: Array<Upload>;
  /**
   *
   * @type {string}
   * @memberof QacConversationMessage
   */
  status: QacConversationMessageStatusEnum;
  /**
   *
   * @type {string}
   * @memberof QacConversationMessage
   */
  errorReason?: string;
  /**
   *
   * @type {QacConversationTokenUsage}
   * @memberof QacConversationMessage
   */
  tokenUsage?: QacConversationTokenUsage;
  /**
   * Time when the activity was performed
   * @type {string}
   * @memberof QacConversationMessage
   */
  createdAt: string;
  /**
   * Time when the activity was performed
   * @type {string}
   * @memberof QacConversationMessage
   */
  updatedAt?: string;
}

export function QacConversationMessageFromJSON(
  json: any
): QacConversationMessage {
  return {
    id: json["id"],
    thread: json["thread"],
    authorType: json["author_type"],
    author: !exists(json, "author")
      ? undefined
      : UserMinifiedFromJSON(json["author"]),
    role: !exists(json, "role") ? undefined : json["role"],
    content: json["content"],
    contentHtml: !exists(json, "content_html")
      ? undefined
      : json["content_html"],
    attachments: !exists(json, "attachments")
      ? undefined
      : (json["attachments"] as Array<any>).map(UploadFromJSON),
    status: json["status"],
    errorReason: !exists(json, "error_reason")
      ? undefined
      : json["error_reason"],
    tokenUsage: !exists(json, "token_usage")
      ? undefined
      : QacConversationTokenUsageFromJSON(json["token_usage"]),
    createdAt: json["created_at"],
    updatedAt: !exists(json, "updated_at") ? undefined : json["updated_at"],
  };
}

export function QacConversationMessageToJSON(
  value?: QacConversationMessage
): any {
  if (value === undefined) {
    return undefined;
  }
  return {
    id: value.id,
    thread: value.thread,
    author_type: value.authorType,
    author: UserMinifiedToJSON(value.author),
    role: value.role,
    content: value.content,
    content_html: value.contentHtml,
    attachments:
      value.attachments === undefined
        ? undefined
        : (value.attachments as Array<any>).map(UploadToJSON),
    status: value.status,
    error_reason: value.errorReason,
    token_usage: QacConversationTokenUsageToJSON(value.tokenUsage),
    created_at: value.createdAt,
    updated_at: value.updatedAt,
  };
}

/**
 * @export
 * @enum {string}
 */
export enum QacConversationMessageAuthorTypeEnum {
  User = "user",
  Copilot = "copilot",
  System = "system",
}
/**
 * @export
 * @enum {string}
 */
export enum QacConversationMessageRoleEnum {
  User = "user",
  Assistant = "assistant",
  System = "system",
}
/**
 * @export
 * @enum {string}
 */
export enum QacConversationMessageStatusEnum {
  Queued = "queued",
  InProgress = "in_progress",
  Completed = "completed",
  Error = "error",
}
